import type { WebRoutine } from './routines';

/**
 * Who the card names: the agent that last worked the routine — its own name, else the roster's for its id.
 * `agentId` is that LAST WORKER, not an owner, so a routine that has run with no agent was run by the Maestro
 * (the daily team meeting), and one that has never run names nobody rather than claiming the Maestro did.
 */
export function routineAgentTag(
  routine: Pick<WebRoutine, 'agentId' | 'agentName' | 'lastRun' | 'runCount' | 'runsKnown'>,
  rosterName: string | undefined,
  maestroName: string,
): { label: string; maestro: boolean } | null {
  const named = routine.agentName?.trim() || rosterName?.trim();
  if (routine.agentId) return named ? { label: named, maestro: false } : null;
  if (named) return { label: named, maestro: false };
  // Only a KNOWN run history says it ran (`routineActivity` treats a lastRun without `runsKnown` as unknown).
  const hasRun = !!routine.runsKnown && (!!routine.lastRun || (routine.runCount ?? 0) > 0);
  return hasRun ? { label: maestroName, maestro: true } : null;
}
